import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  packageOption: {
    id: '+AzuYm',
    defaultMessage: 'Package',
    description: 'Segmented control option for standard package shipment type',
  },
  freightOption: {
    id: 'UxDYvQ',
    defaultMessage: 'Freight',
    description: 'Segmented control option for freight shipment type',
  },
  updateFailed: {
    id: 'zlYHpg',
    defaultMessage: 'Failed to update shipment type. Please try again.',
    description: 'Error notification when changing the shipment type (freight/package) fails',
  },
});
